"use client";
import { useCallback, useState } from "react";

import { CREATE_NEW_WORKSPACE_ROUTE } from "@stadium/constants/routes";

const MIN_WORKSPACES_FOR_NUDGE = 2;

const useCreateWorkspaceNudge = ({ isNudgeEnabled = false, workspaces = [] }) => {
  const [showCreateWorkspaceModal, setShowCreateWorkspaceModal] = useState(false);
  const workspaceCount = workspaces?.length ?? 0;

  const handleCreateWorkspaceClick = useCallback(() => {
    if (isNudgeEnabled && workspaceCount >= MIN_WORKSPACES_FOR_NUDGE) {
      setShowCreateWorkspaceModal(true);
      return;
    }

    globalThis.location.assign(CREATE_NEW_WORKSPACE_ROUTE);
  }, [isNudgeEnabled, workspaceCount]);

  const closeCreateWorkspaceModal = useCallback(() => {
    setShowCreateWorkspaceModal(false);
  }, []);

  return {
    closeCreateWorkspaceModal,
    handleCreateWorkspaceClick,
    showCreateWorkspaceModal,
  };
};

export default useCreateWorkspaceNudge;
